import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css";
import Footer from "../components/Footer";
import { FaPaperPlane } from "react-icons/fa";

export default function Contact() {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type: "success"|"error", message: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setFeedback(null);

    try {
      const result = await emailjs.sendForm(
        "service_pe2710o",
        "template_a7apc0w",
        form.current,
        "lHeYzJzirNa7NiBBf"
      );

      console.log("Email sent:", result.text);
      setFeedback({
        type: "success",
        message: "Thanks—your message is on its way!",
      });
    } catch (error) {
      console.error("Email error:", error.text);
      setFeedback({
        type: "error",
        message: "Oops—something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
      e.target.reset();
    }
  };

  return (
    <>
      <section className="contact-section">
        <div className="container">
          <div className="contact-header">
            <h1 className="section-title">Get In Touch</h1>
            <p className="contact-subtitle">
              I'm always open to discussing new opportunities, interesting
              projects, or just having a chat about technology. Feel free to
              reach out!
            </p>
          </div>

          {/* <div className="contact-content"> */}
          {/* <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h3>Email</h3>
                  <p>david.olowomeye@gmail.com</p>
                </div>
              </div>
              
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <h3>Phone</h3>
                  <p>+234 803 123 4567</p>
                </div>
              </div>
              
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <h3>Location</h3>
                  <p>Lagos, Nigeria</p>
                </div>
              </div>
            </div> */}

          <div className="form-container">
            <form className="contact-form" ref={form} onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message"
                  rows="5"
                  required
                />
              </div>

              <button
                className="btn-primary"
                type="submit"
                disabled={isLoading}
              >
                <FaPaperPlane />
                {isLoading ? "Sending..." : "Send Message"}
              </button>

              {feedback && (
                <div className={`feedback ${feedback.type}`}>
                  {feedback.message}
                </div>
              )}
            </form>
          </div>
        </div>
        {/* </div> */}
      </section>

      <Footer />
    </>
  );
}
